import { HTTP_METHODS } from '@studio/constants/axios';
import { MEDIA_METADATA_API_V1 } from '@studio/constants/env-variables';
import type { Clips } from '@studio/types';

export const root = {
  [HTTP_METHODS.GET]: {
    url: `${MEDIA_METADATA_API_V1}/customers/@customerId/clips`,
    response: [] as Clips.Get.Clip[],
    method: HTTP_METHODS.GET,
  },
  [HTTP_METHODS.POST]: {
    url: `${MEDIA_METADATA_API_V1}/customers/@customerId/clips`,
    request: {} as Clips.Post.Clip,
    response: {} as Clips.Get.Clip,
    method: HTTP_METHODS.POST,
  },
};

export const id = {
  [HTTP_METHODS.GET]: {
    url: `${MEDIA_METADATA_API_V1}/customers/@customerId/clips/@id`,
    response: {} as Clips.Get.Clip,
    method: HTTP_METHODS.GET,
  },
  [HTTP_METHODS.PATCH]: {
    url: `${MEDIA_METADATA_API_V1}/customers/@customerId/clips/@id`,
    request: {} as Clips.Patch.Clip,
    response: {} as Clips.Get.Clip,
    method: HTTP_METHODS.PATCH,
  },
  [HTTP_METHODS.DELETE]: {
    url: `${MEDIA_METADATA_API_V1}/customers/@customerId/clips/@id`,
    params: {} as { id: string },
    method: HTTP_METHODS.DELETE,
  },
};
